import i18n from '@/plugins/i18n'

export default [
    {
        path: '/' + i18n.t('roles.routes.index'),
        name: 'role.index',
        child: false,
        component: () =>
            import(/* webpackChunkName: "roles" */ '@/views/roles/Index.vue'),
        meta: {
            requiresAuth: true,
            breadcrumb: [
                {
                    text: i18n.t('roles.breadcrumbs.index'),
                    to: { name: 'role.index' },
                    disable: true,
                },
            ],
            showName: i18n.t('roles.breadcrumbs.index'),
        },
    },
    {
        path: '/' + i18n.t('roles.routes.create'),
        name: 'role.create',
        child: true,
        component: () =>
            import(/* webpackChunkName: "roles" */ '@/views/roles/Create.vue'),
        meta: {
            requiresAuth: true,
            breadcrumb: [
                {
                    text: i18n.t('roles.breadcrumbs.index'),
                    to: { name: 'role.index' },
                    disable: false,
                },
                {
                    text: i18n.t('roles.breadcrumbs.create'),
                    to: { name: 'role.create' },
                    disable: true,
                },
            ],
        },
    },
    {
        path: '/' + i18n.t('roles.routes.edit') + '/:id',
        name: 'role.edit',
        child: true,
        component: () =>
            import(/* webpackChunkName: "roles" */ '@/views/roles/Edit.vue'),
        meta: {
            requiresAuth: true,
            breadcrumb: [
                {
                    text: i18n.t('roles.breadcrumbs.index'),
                    to: { name: 'role.index' },
                    disable: false,
                },
                {
                    text: i18n.t('roles.breadcrumbs.edit'),
                    to: { name: 'role.edit' },
                    disable: true,
                },
            ],
        },
        props: true,
    },
]
